
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export default function Card({ children, className = '', hover = false }: CardProps) {
  return (
    <div className={`bg-white rounded-xl shadow-lg ${hover ? 'hover:shadow-xl transition-shadow duration-300 cursor-pointer' : ''} ${className}`}>
      {children}
    </div>
  );
}
